<template>
  <div class="vx-row">
    <div class="vx-col w-full flex flex-col">
      <vs-button
        @click="$router.push({name: 'agencies-create'})"
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        class="mb-4 self-end"
        size="medium"
      >Tambah Dinas</vs-button>
      <vs-card>
        <div slot="header">
          <div class="vx-row m-2">
            <h3>Dinas Tergabung</h3>
          </div>
        </div>
        <div slot="header">
          <div class="vx-row flex flex-col m-0  w-full">
            <div class="flex w-full ">
              <div class="flex-1 p-2">
                <div class="w-full">
                  <vs-input icon-pack="feather" icon="icon-search" placeholder="Cari Nama / Inisial Instansi"
                    v-model="filterSearch" class=" w-full" />
                </div>
              </div>
              <div class="w-full p-2  md:w-1/4">
                <v-select :options="listStatus" v-model="agencyStatus" />
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col">
          <vs-table :data="agencies">
            <template slot="thead">
              <vs-th>No.</vs-th>
              <vs-th>Nama Dinas</vs-th>
              <vs-th>Alamat</vs-th>
              <vs-th>Status</vs-th>
              <vs-th>Action</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">{{ indextr }}</vs-td>
                <vs-td :data="tr.nama">{{ tr.initial }}</vs-td>
                <vs-td :data="tr.alamat">{{ tr.address }}</vs-td>
                <vs-td :data="tr.alamat">{{ tr.status ? 'Aktif' : 'Tidak Aktif' }}</vs-td>
                <vs-td>
                  <div class="vx-row">
                    <vs-button
                      @click="$router.push({name: 'agencies-detail', params: {id: tr.id}})"
                      color="primary"
                      size="small"
                      class="m-1"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                    >Detail</vs-button>
                    <!-- <vs-button
                      @click="$router.push({name: 'agencies-edit', params: {id: tr.id}})"
                      color="success"
                      size="small"
                      class="m-1"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit"
                    >Edit</vs-button> -->
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import _ from "lodash";

export default {
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      agencies: [],
      filterSearch: '',
      agencyStatus: {
        value: 1,
        label: "AKTIF"
      },
      listStatus : [
        { value: 1, label: "AKTIF" },
        { value: 0,label: "TIDAK AKTIF"},
      ]
    };
  },
  mounted() {
    this.fetchDataAgency();
  },
  watch: {
    filterSearch: _.debounce(function (query) {
      this.fetchDataAgency(query);
    }, 500),
    agencyStatus() {
      this.fetchDataAgency();
    },
  },
  methods: {
    fetchDataAgency() {
      this.$vs.loading();
      let data = {
        status : this.agencyStatus.value,
        search : this.filterSearch
      };

      this.$http
        .get(`/app/secure/agency`, {params : data})
        .then(r => {
          this.agencies = r.data.data.agencies;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }
  }
};
</script>>
